import axiosInstance from "../utils/axios";

export const programStudyService = {
  fetchAllWithoutPaginate: async () => {
    const response = await axiosInstance.get("/program-study/all");
    return response.data;
  },
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get("/program-study", { params });
    return response.data;
  },
  findById: async (id) => {
    const response = await axiosInstance.get("/program-study/" + id);
    return response.data;
  },
  store: async (data) => {
    const response = await axiosInstance.post("/program-study", data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axiosInstance.put(`/program-study/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await axiosInstance.delete(`/program-study/${id}`);
    return response.data;
  },
};
